import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=43162c7a&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./Loader.styl?vue&type=style&index=0&id=43162c7a&prod&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43162c7a",
  null
  
)

export default component.exports